<template>
  <div ref="container">
    <a-modal :title="title" :width="800" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <div class="box">
        <span>绑定账号:</span><a-input style="width:90%" @click="Bindaccount" v-model:value="value" placeholder="请点击进行操作绑定账号" />
      </div>
      <a-table :dataSource="dataSource" :pagination="pagination" :columns="columns" :loading="loading" :locale="{emptyText:'暂未绑定账号'}">
        <span slot="action" slot-scope="text, record">
          <a-popconfirm title="确定解除账号信息吗?" @confirm="() => handleEdit()">
            <a>解除绑定</a>
          </a-popconfirm>
        </span>
      </a-table>
    </a-modal>
    <AccountListModel ref="AccountListModelref" @change="costPlannedAmountChange($event)" @ok="modalFormOk"></AccountListModel>
  </div>
</template>
<script>
import AccountListModel from './AccountListModel'
import { getSerNumbers, getuserApi, unBindUser } from '@/api/api'
export default {
  name: 'VendorModal',
  components: {
    AccountListModel,
  },
  data() {
    return {
      title: '账号信息',
      visible: false,
      value: '',
      form: {},
      model: {},
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
      dataSource: [],
      loading: false,
      columns: [
        {
          title: '操作',
          dataIndex: 'action',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '登录名称',
          dataIndex: 'loginName',
          width: 100,
        },
        {
          title: '用户姓名',
          dataIndex: 'username',
          width: 100,
        },
        {
          title: '角色',
          dataIndex: 'roleName',
          width: 100,
        },
      ],
    }
  },
  created() {},
  methods: {
    async add(e) {
      console.log(e, 'e122')
      if (e) {
        this.form = e
      }
      this.visible = true
      this.pagination.current = 1
      this.loading = true
      if (e.userId) {
        this.getlist(e.userId)
      } else {
        this.dataSource = []
        this.loading = false
      }
      // const res = await getSerNumbers({ id: e.id })
      // console.log(res, 'res')
      // if (res.code == 100) {
      //   this.loading = false
      //   this.dataSource = res.data.map((it) => {
      //     return { code: it }
      //   })
      // } else {
      //   this.$message.error(res.data || res.msg)
      //   this.loading = false
      // }
    },
    async getlist(id) {
      this.loading = true
      let params = {
        search: this.queryParam,
        currentPage: 1,
        pageSize: 10,
      }
      const res = await getuserApi(params)
      console.log(res, 'res')
      if (res.code == 200) {
        this.dataSource = res.data.rows.filter((it) => it.id == id)
        this.loading = false
      } else {
        this.$message.error(res.data || res.msg)
        this.loading = false
      }
    },
    Bindaccount() {
      if (this.dataSource.length > 0) return this.$message.warning('已有绑定账号信息')
      this.$refs.AccountListModelref.add(this.form)
    },
    costPlannedAmountChange(value) {
      this.dataSource = value
    },
    modalFormOk() {
      this.$emit('ok')
    },
    async handleEdit() {
      this.loading = true
      const res = await unBindUser({ id: this.form.id })
      console.log(res, 'res')
      if (res.code == 200) {
        this.$message.success('解除绑定成功')
        this.dataSource = []
        this.loading = false
      } else {
        this.$message.error(res.data || res.msg)
        this.loading = false
      }
    },
    close() {
      this.$emit('ok')
      this.visible = false
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
    handlePageChange(page, pageSize) {
      console.log(page, 'page')
      console.log(pageSize, 'pageSize')
      this.pagination.current = page
    },
  },
}
</script>

<style scoped>
.box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
</style>